import React from 'react';
import {motion} from 'framer-motion';

const VideoSection = () => {
  return (
    <section className="py-16 bg-secondary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 mb-4">
            How to Apply for Life Insurance Online in California
          </h2>
          <p className="text-lg text-secondary-600 max-w-3xl mx-auto">
            Watch our step-by-step guide to getting life insurance coverage in just minutes. No paperwork, no medical exams for most applicants.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto"
        >
          <div className="relative bg-black rounded-lg overflow-hidden shadow-2xl aspect-video">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/qIo_x5B9Kdk"
              title="How to Apply for Life Insurance Online in California"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>

          <div className="mt-8 text-center">
            <a
              href="https://quote.burbankinsuranceservices.com/Dt2tCn"
              className="inline-flex items-center px-8 py-3 bg-primary-600 text-white font-semibold rounded-lg hover:bg-primary-700 transition-colors shadow-lg"
            >
              Start Your Application Now
            </a>
            <p className="mt-2 text-sm text-secondary-500">
              Takes less than 5 minutes • No medical exam required
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VideoSection;